import React from "react";
import { KopHeader, TTDBlock } from "./PrintHeader";

/**
 * Dokumen NILAI SIKAP DAN PERILAKU PERORANGAN (Sosiometri)
 */
export default function PrintSosio({ settings = {}, siswa = {}, raters = {}, sosio_values = {}, unsur_penilaian = [], periode = {}, showSignature = true }) {
  const kategoriBlocks = [];
  let current = null;
  unsur_penilaian.forEach((u) => {
    if (!current || current.kategori !== u.kategori) {
      current = { kategori: u.kategori, label: u.kategori_label, items: [] };
      kategoriBlocks.push(current);
    }
    current.items.push(u);
  });

  return (
    <div className="print-doc bg-white text-black mx-auto" style={{ width: "200mm", padding: "10mm 12mm", boxShadow: "0 0 8px rgba(0,0,0,0.08)", fontFamily: "Arial, sans-serif", fontSize: "11pt" }}>
      <KopHeader line1={settings.kop_l1} line2={settings.kop_l2} />

      <div style={{ textAlign: "center", margin: "16px 0 14px" }}>
        <div style={{ fontWeight: "bold", letterSpacing: 1 }}>NILAI SIKAP DAN PERILAKU PERORANGAN</div>
      </div>

      <table style={{ marginBottom: 12, border: "none", width: "100%" }}>
        <tbody>
          <tr>
            <td style={{ border: "none", width: 130, padding: "1px 4px" }}>Pendidikan</td>
            <td style={{ border: "none", width: 10, padding: "1px 0" }}>:</td>
            <td style={{ border: "none", padding: "1px 4px" }}>{settings.pendidikan}</td>
            <td style={{ border: "none", padding: "1px 4px", width: 90, textAlign: "right" }}>{periode.jenis === "bulanan" ? "Bulanan ke" : "Mingguan ke"}</td>
            <td style={{ border: "none", padding: "1px 0", width: 10 }}>:</td>
            <td style={{ border: "none", padding: "1px 4px", width: 80, fontWeight: "bold" }}>{periode.nomor ?? "—"}</td>
          </tr>
          <tr>
            <td style={{ border: "none", padding: "1px 4px" }}>Serdik</td>
            <td style={{ border: "none", padding: "1px 0" }}>:</td>
            <td style={{ border: "none", padding: "1px 4px", width: 250 }}>{siswa.nama}</td>
            <td style={{ border: "none", padding: "1px 4px", width: 60 }}>Nosis</td>
            <td style={{ border: "none", padding: "1px 0", width: 10 }}>:</td>
            <td style={{ border: "none", padding: "1px 4px" }}>{siswa.nosis}</td>
          </tr>
          <tr>
            <td style={{ border: "none", padding: "1px 4px" }} colSpan="6">Serdik yang menilai :</td>
          </tr>
          {[["A", raters.a], ["B", raters.b], ["C", raters.c]].map(([k, r]) => (
            <tr key={k}>
              <td style={{ border: "none", padding: "1px 4px", paddingLeft: 22 }}>{k}.</td>
              <td style={{ border: "none", padding: "1px 0" }}></td>
              <td style={{ border: "none", padding: "1px 4px" }}>{r?.nama || "—"}</td>
              <td style={{ border: "none", padding: "1px 4px" }}>Nosis</td>
              <td style={{ border: "none", padding: "1px 0" }}>:</td>
              <td style={{ border: "none", padding: "1px 4px" }}>{r?.nosis || ""}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ width: 40, textAlign: "center" }}>NO</th>
            <th style={{ textAlign: "center" }}>UNSUR PENILAIAN</th>
            <th style={{ width: 38, textAlign: "center" }}>A</th>
            <th style={{ width: 38, textAlign: "center" }}>B</th>
            <th style={{ width: 38, textAlign: "center" }}>C</th>
            <th style={{ width: 50, textAlign: "center" }}>RATA</th>
          </tr>
          <tr>
            <th style={{ textAlign: "center" }}>1</th>
            <th style={{ textAlign: "center" }}>2</th>
            <th style={{ textAlign: "center" }}>3</th>
            <th style={{ textAlign: "center" }}>4</th>
            <th style={{ textAlign: "center" }}>5</th>
            <th style={{ textAlign: "center" }}>6</th>
          </tr>
        </thead>
        <tbody>
          {kategoriBlocks.map((kb) => (
            <React.Fragment key={kb.kategori}>
              <tr>
                <td style={{ fontWeight: "bold", textAlign: "center" }}>{kb.kategori}</td>
                <td colSpan="5" style={{ fontWeight: "bold" }}>{kb.label.replace("MENTAL ", "Mental ")}</td>
              </tr>
              {kb.items.map((u) => {
                const v = sosio_values[String(u.no)] || {};
                const a = v.a || 0;
                const b = v.b || 0;
                const c = v.c || 0;
                const filled = [a, b, c].filter((x) => x > 0).length;
                const rata = filled > 0 ? ((a + b + c) / filled).toFixed(2) : "";
                return (
                  <tr key={u.no}>
                    <td style={{ textAlign: "center" }}>{u.no}</td>
                    <td style={{ textAlign: "left" }}>{u.nama}</td>
                    <td style={{ textAlign: "center" }}>{a || ""}</td>
                    <td style={{ textAlign: "center" }}>{b || ""}</td>
                    <td style={{ textAlign: "center" }}>{c || ""}</td>
                    <td style={{ textAlign: "center" }}>{rata}</td>
                  </tr>
                );
              })}
            </React.Fragment>
          ))}
        </tbody>
      </table>

      {showSignature && (
        <TTDBlock
          lokasi={settings.lokasi}
          bulan={(periode && periode.bulan) || settings.bulan}
          tahun={(periode && periode.tahun) || settings.tahun}
          jabatan={settings.jabatan_penandatangan}
          nama={settings.nama_komandan}
          pangkat={settings.pangkat_komandan}
          nrp={settings.nrp_komandan}
        />
      )}
    </div>
  );
}
